import { createContext, PropsWithChildren, useState, useContext } from 'react'

const ConfettiCtx = createContext({ confetties: [] as number[], start: () => { } })

let confettiId = 0

export const ConfettiCtxProvider = ({ children }: PropsWithChildren) => {
  const [confetties, setConfetties] = useState<number[]>([])
  function start() {
    setConfetties((prev) => [...prev, confettiId++])
    setTimeout(() => {
      setConfetties((prev) => prev.filter((i) => i !== confettiId - 1))
    }, 3000)
  }
  return (
    <ConfettiCtx.Provider value={{ confetties, start }}>{children}</ConfettiCtx.Provider>
  )
}

export function useConfetti() {
  return useContext(ConfettiCtx)
}
